var render = function render(){var _vm=this,_c=_vm._self._c;return _c('em-z-tree',{ref:"bomTree",attrs:{"treeNodes":_vm.bomTreeNodes,"chkboxType":_vm.chkboxType,"textKeys":"chineseName","checkEnable":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }